import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Zap, Users, MonitorPlay } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const MODOS = [
  { icon: Users, t: "Clases tradicionales", d: "Presencial en el aula, con profesor y rutina de estudio." },
  { icon: Zap, t: "Intensivo: teórico en 1 semana", d: "Resumimos lo que cae en el examen y apuras los tiempos.", star: true },
  { icon: MonitorPlay, t: "Plataforma online", d: "Temas grabados + test de examen, a tu ritmo y a cualquier hora." },
];

export default function TeoricaSection() {
  return (
    <section className="py-16 sm:py-20 bg-[var(--faro-blue-deep)] text-white" data-testid="teorica-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-[var(--faro-yellow)]">La teórica, a tu ritmo</span>
          <h2 className="font-display font-black tracking-tight text-3xl sm:text-4xl mt-2 max-w-2xl">
            ¿Con prisa? Sácate el teórico en 1 semana con el intensivo
          </h2>
        </Reveal>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {MODOS.map((m, i) => (
            <Reveal key={m.t} delay={i * 0.08}>
              <div
                data-testid={`teorica-modo-${i}`}
                className={`h-full rounded-2xl p-5 ${m.star ? "bg-[var(--faro-yellow)] text-[var(--faro-blue-deep)]" : "bg-white/5 border border-white/15"}`}
              >
                <m.icon size={22} className={m.star ? "text-[var(--faro-red)]" : "text-[var(--faro-yellow)]"} />
                <h3 className="font-display font-bold text-lg mt-3">{m.t}</h3>
                <p className={`text-sm mt-1 ${m.star ? "opacity-80" : "text-white/75"}`}>{m.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.25}>
          <Link to="/curso-intensivo-teorica-vigo" className="mt-8 inline-flex btn-pill btn-primary text-sm" data-testid="teorica-section-cta">
            Descubre el intensivo de teórica <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
